import _ from "lodash";
import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";
import { MapMouseEvent, useMap } from "react-map-gl";
import { useMapStore } from "../..";
import useIsHalfScreenMap from "../../hooks/useIsHalfScreenMap";
import usStateAbbrev from "../../utils/usStateAbbrev";
import { minZoom } from "../mapConfig";
import { countyFillLayerId } from "../mapLayers/CountiesMapLayer";
import { regridIosZoningLayerId, regridZoningInfoLayerId } from "../mapLayers/RegridZoningMapLayer";
import { stateShapesLayerId } from "../mapLayers/StateShapesMapLayer";
import styles from "./StatusPanelMapControl.module.css";

function StatusPanelMapControl() {
    const { map } = useMap();
    const isHalfScreenMap = useIsHalfScreenMap();
    const mapStore = useMapStore();
    const [countyName, setCountyName] = useState("");
    const [state, setState] = useState("");
    const [zoning, setZoning] = useState("");
    const [isIosZoning, setIsIosZoning] = useState(false);

    const getUpdateStatusCallback = (zoningLayerIds: string[]) => (e: MapMouseEvent) => {
        const countyFeature = e.features ? e.features.find(f => f.layer?.id == countyFillLayerId) : null;
        if (countyFeature)
            setCountyName(countyFeature.properties!.NAME);

        const stateFeature = e.features ? e.features.find(f => f.layer?.id === stateShapesLayerId) : null;
        if (stateFeature)
            setState(usStateAbbrev[stateFeature.properties!.NAME]);

        if (e.type === "mouseleave") {
            setZoning("");
            setIsIosZoning(false);
        } else {
            const zoningFeature = e.features ? e.features.find(f => _.includes(zoningLayerIds, f.layer?.id)) : null;
            setZoning(zoningFeature?.properties!.zoning);

            const isIOSZoning = e.features ? e.features.some(f => (f.layer?.id as string).toLowerCase().includes("ios")) : false;
            setIsIosZoning(isIOSZoning);
        }
    };

    useEffect(() => {
        if (!map || !mapStore.isStyleLoaded)
            return;

        const zoningLayerIds = [regridZoningInfoLayerId];
        const iosZoningLayerIds = map.getStyle()!.layers
            .filter((l: any) => l.id.includes(regridIosZoningLayerId))
            .map(l => l.id);

        map.on("mousemove", [...zoningLayerIds, ...iosZoningLayerIds, stateShapesLayerId, countyFillLayerId], getUpdateStatusCallback(zoningLayerIds));
        map.on("mouseleave", [...zoningLayerIds, ...iosZoningLayerIds, stateShapesLayerId, countyFillLayerId], getUpdateStatusCallback(zoningLayerIds));
    }, [map, mapStore.isStyleLoaded]);

    return mapStore.viewState.zoom > 5 && countyName && state
        ? (
            <div className={[
                isHalfScreenMap ? styles.halfScreenContainer : styles.container,
                isIosZoning ? styles.iosZoning : "",
            ].join(" ")}>
                {countyName}, {state} {zoning && (mapStore.viewState.zoom > minZoom.zoning) && ` | ${zoning}`}
            </div>
        ) : null;
}

export default observer(StatusPanelMapControl);